import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import { CardMedia } from "@mui/material";
import ImageModal from "./ImageModal";
import EditCommentIcon from "@images/EditComment.svg";
import { useSelector } from "react-redux";
import MentionedTextWrapper from "./MentionedTextWrapper";
import { regexReplacers } from "@helpers";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  textColor: {
    color: theme.palette.primary.main,
  },
  bgGreen: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
  },
  bgGrey: {
    backgroundColor: "#efefef",
    color: "#000",
  },
  textGrey: {
    color: "#626262",
  },
  colorGreen: {
    backgroundColor: "#e5f8f1",
  },
}));

function CommentText({ children, media, user, time, onEdit, readOnly = false, overwrittenBy }) {
  const [openImageModal, setOpenImageModal] = useState(false);
  const classes = useStyles();
  const { userRecord } = useSelector((state) => state.user);

  const commentText = (() => {
    if (!children) return "";

    // First replace URLs with anchor tags similar to Post.js
    const urlRegex = new RegExp(
      "(?:https?:\\/\\/|www\\.)[A-Za-z0-9._~:/?#[\\]@!$&'()*+,;=%-]+|[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\\.[A-Za-z]{2,})+(?:\\/[^\\s<>'\"]*)?",
      "gi",
    );

    const withLinks = children.replace(urlRegex, (url) => {
      const href = /^https?:\/\//i.test(url)
        ? url
        : `https://${url.startsWith("www.") ? "" : "www."}${url}`;
      let displayText = url;
      try {
        displayText = new URL(href).hostname.replace(/^www\./, "");
      } catch (e) {}
      return `<a href="${href}" target="_blank" rel="noreferrer noopener" class="underline cursor-pointer text-blue-500">${displayText}</a>`;
    });

    return withLinks
      .replace(regexReplacers.emoji.exp, regexReplacers.emoji.rep)
      .replace(regexReplacers.style.exp, regexReplacers.style.rep)
      .replace(regexReplacers.script.exp, regexReplacers.script.rep);
  })();

  return (
    <div className="grow">
      <div className={clsx("flex justify-start")}>
        <div className="flex flex-col grow">
          <div
            className={clsx(
              `leading-1.5 mt-2 flex flex-col rounded-e-xl  rounded-ss-xl py-2 px-2`,
              classes.bgGrey
            )}
          >
            {media?.currBucketUrl &&
              (media?.fileType === "video" ? (
                <CardMedia
                  controlsList="nodownload"
                  crossOrigin="anonymous"
                  component={"video"}
                  controls
                  className="mx-auto h-52 w-11/12 rounded-2xl object-contain"
                  image={media?.currBucketUrl}
                  alt="Stream Media"
                  autoPlay
                  muted
                />
              ) : (
                <img
                  onClick={() => setOpenImageModal(true)}
                  className=" mb-3 h-40 bg-white object-contain cursor-pointer"
                  src={media?.currBucketUrl}
                  alt="Media"
                />
              ))}
            <div style={{ fontSize: "12px" }}>
              <p className="flex">
                <Link to={`/${user?.userName}`}>
                  <span className="text-sm font-semibold">
                    {user?.userName}
                  </span>
                </Link>
                {overwrittenBy && (
                  <span className="pl-2">(Overwritten)</span>
                )}
                <span className="pl-2">{time}</span>

                {userRecord?.id === user?.id && !readOnly && (
                  <span
                    className="ml-auto mr-1 self-center cursor-pointer"
                    onClick={onEdit}
                  >
                    <img src={EditCommentIcon} alt="edit" />
                  </span>
                )}
              </p>
              <p className="font-normal text-base">
                <MentionedTextWrapper>{commentText}</MentionedTextWrapper>
              </p>
            </div>
          </div>
        </div>
      </div>
      <ImageModal
        url={media?.currBucketUrl}
        open={openImageModal}
        setOpen={setOpenImageModal}
      />
    </div>
  );
}

export default CommentText;
